const mainHeader = document.querySelector('.block-primary-navigation');
const peopleSingle = document.querySelector('.people-single');
const peopleHeader = document.querySelector('.people-single__grid');
const contentTabs = document.querySelectorAll('.block-content-section');
let headerIsSticky = false;
let peopleHeaderHeight = peopleHeader.offsetHeight;

const updateHeroOnResize = () => {
	const browserWidth = window.innerWidth;

	peopleHeaderHeight = peopleHeader.offsetHeight;
	headerIsSticky = false;
	peopleHeader.style = '';

	if (browserWidth < 1024) {
		peopleSingle.classList.remove('sticky');
		peopleSingle.style.paddingTop = '0px';
	}
};

const toggleHeroSize = () => {
	const browserWidth = window.innerWidth;
	if (browserWidth >= 1024) {
		if (window.scrollY >= peopleHeaderHeight - 88 && !headerIsSticky) {
			headerIsSticky = true;
			peopleSingle.classList.add('sticky');
			peopleSingle.style.paddingTop = peopleHeaderHeight - 88 + 'px';
			console.log(mainHeader);
			peopleHeader.style.top = mainHeader.offsetHeight + 'px';
		} else if (window.scrollY < peopleHeaderHeight - 88 && headerIsSticky) {
			headerIsSticky = false;
			peopleSingle.classList.remove('sticky');
			peopleSingle.style.paddingTop = '0px';
		}
	}
};

const languages = () => {
	const lang = (
		(navigator.languages && navigator.languages[0]) ||
		navigator.language ||
		navigator.userLanguage ||
		'en'
	).substr(0, 2);
	const personLang = [];
	contentTabs.forEach((tab) => {
		const langContent = tab.querySelectorAll('div[lang]');
		const langCount = langContent.length;

		langContent.forEach((content) => {
			const HTMLLang = content.getAttribute('lang');
			personLang.push(HTMLLang);
			if (HTMLLang !== lang && langCount > 1) {
				content.style.display = 'none';
			}
		});
	});

	if (!personLang.includes(lang)) {
		const langDiv = document.querySelector('div[lang="en"]');
		if (langDiv) {
			langDiv.style.display = 'block';
		}
	}
};

const backToTop = () => {
	const backToTopButton = document.querySelectorAll('.back-to-top button');
	if (backToTopButton) {
		backToTopButton.forEach((button) => {
			button.addEventListener('click', () => {
				window.scrollTo({ top: 0, behavior: 'smooth' });
			});
		});
	}
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		toggleHeroSize();
		//languages(); // Disabled language detection for people profiles since we are moving to language translations with Weglot
		backToTop();
	},
	loaded() {},
	resized() {
		updateHeroOnResize();
	},
	scrolled() {
		toggleHeroSize();
	},
	keyDown() {},
	mouseUp() {},
};
export default controller;
